<template>
  <div>
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>

import {loadScript} from 'devegram-javascript-util'

export default {
  data () {
    return {
      productName: $store.state['app-state'].productName
    }
  },
  mounted() {
    let basePath = '/portals/home/'+ this.productName + '/js'
    loadScript([
      {
        src: basePath + '/main.js',
        onload: function () {
          /*loadScript([
              {src: basePath + 'jquery.scrolly.min.js'},
              {src: basePath + 'query.scrollex.min.js'},
              {src: basePath + 'browser.min.js'},
              {src: basePath + 'breakpoints.min.js'},
              {src: basePath + 'util.js'},
              {src: basePath + '/theme-js/mixitup.min.js'},
              {src: basePath + 'main.js'},
          ])*/
        }
      }
    ])


    let routesStyle = [
      'portal-home-profile',
      'portal-home-login',
      'portal-home-signup',
      'portal-home-successful-payment'
    ]

    let cssBase = '/portals/home/'+ this.productName + '/css'
    if (routesStyle.indexOf(this.$route.name) != -1) {
      let styles = [
        cssBase +'/main.css',
      ]
      for (let x in styles) {
        let element = document.createElement("link");
        element.setAttribute("rel", "stylesheet");
        element.setAttribute("type", "text/css");
        element.setAttribute("portal", "portal-home");
        element.setAttribute("href", styles[x]);
        document.getElementsByTagName("head")[0].appendChild(element);
      }
    }
  }
}
</script>
